import React from "react";
import { getPortfolioItem } from "../../api/portfolio/PortfolioData";

import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import ButtonDefault from "../../components/button/button-default/ButtonDefault";
import BoxImageVertical from "../../components/box-image-vertical/BoxImageVertical";
import { Container } from "react-bootstrap";
import FadeUpTrigger from "../../animation/FadeUpTrigger";
import TextTrigger from "../../animation/TextTrigger";
import DsnGrid from "../../components/DsnGrid";
//--> Component
import HeaderHalf from "../../components/header/HeaderHalf";
import TitleCover from "../../components/heading/title-cover/TitleCover";
import ButtonProject from "../../components/button/button-project/ButtonProject";
import NextProject from "../../components/next/NextProject";
import BoxRight from "../../components/box-right/BoxRight";
import ParallaxImage from "../../components/parallax-image/ParallaxImage";
import { Helmet } from 'react-helmet-async';

const FlavorVote = ({ data }) => {
  const nextData = getPortfolioItem(5);

  return (
    <React.Fragment>
      <Helmet>
        <title>Devlift - {data.title} </title>
        <link rel='canonical' href='/portolio/flavour-vote' />
        <meta name="description" content={data.description} />
      </Helmet>
      {/*Start Header Half*/}
      <HeaderHalf heroContent={data} overlay={data.overlay} href="#" >
        {/* <strong className="color-heading">Published </strong> <span> - July 15th 2019 </span> */}
      </HeaderHalf>
      {/*End Header Half*/}

      {/*Start Info Project*/}
      <Container className="section-margin">
        <TitleCover>The Ask</TitleCover>
        <TextTrigger duration={0.8} stagger={0.1}>
          {(ref) => (
            <h2 className="title-section" ref={ref}>
              The Ask
            </h2>
          )}
        </TextTrigger>
        <FadeUpTrigger>
          <p className="mt-20">
            In hopes of creating a unique approach for consumer engagement with the well-known chocolate brand, Mars wanted to launch an accessible web-based promotional marketing solution for the unveiling of the M&M’s Flavour Vote campaign.
          </p>
          <p className="mt-20">
            The experience would allow consumers to choose their favourite new flavour, share their choice with friends via social media and gain entrance into a contest with weekly and grand
            prizes.
          </p>
        </FadeUpTrigger>
      </Container>
      {/*End Info Project*/}

      {/*Start Grid Project*/}
      <Container className="section-margin">
        <DsnGrid
          col={1}
          colGap={50}
          rowGap={50}
          colGapTablet={30}
          rowGapTablet={30}
        >
          <img src="/assets/img/project/flavour-vote/screenshot.png" alt="" />
        </DsnGrid>
      </Container>
      {/*Start Grid Project*/}

      {/*Start Box Info With Image*/}
      <BoxImageVertical
        src="/assets/img/project/flavour-vote/winner.png"
        className="section-margin"
      >
        <FadeUpTrigger>
          {(ref) => (
            <DsnGrid col={1} rowGap={30} rowGapTablet={20}>
              <TitleCover>The Solution</TitleCover>
              <h2 className="title-section border-line-left" ref={ref}>
                The Solution
              </h2>
              <p ref={ref}>
                Using Angular and Flex layout, Devlift was able to create a fully optimized microsite that allowed consumers to discover and interact with the brand. The unique web-based marketing approach deliverd large consumer base engagement with over 25,000 votes in a six week period.
              </p>
              <p ref={ref}>
                Using an age-gate Devlift ensured that only qualified users were able to access the microsite which included several interactive features. Upon entering the site, consumers were greeted with promotional content to inform them of the new products and contest. From there, consumers choose their preferred flavour and gained entry to the contest through simple email
                form submission.
              </p>
              <p ref={ref}>
                In addition to this, consumers were given the choice to upload a personal selfie with M&M’s promotional imagery or preset images representing their vote, and share it over popular social media channels.  Devlift also developed an integrated database solution that helped to select the weekly and grand prize winners in a completely randomized fashion.
              </p>
              {/* <div className="button-box" ref={ref}>
                <ButtonDefault text="launch" icon={faAngleRight} href="#0" />
              </div> */}
            </DsnGrid>
          )}
        </FadeUpTrigger>
      </BoxImageVertical>

      <Container className="section-margin">
        <DsnGrid
          col={1}
          colGap={50}
          rowGap={50}
          colGapTablet={30}
          rowGapTablet={30}
        >
          <img src="/assets/img/project/flavour-vote/header.png" alt="" />
        </DsnGrid>
      </Container>

      <NextProject heroContent={nextData} overlay={nextData.overlay} />
    </React.Fragment>
  );
};

export default FlavorVote;
